#import "~/graphql/fragments/Assets/GenericEntryCardAsset.graphql"
#import "~/graphql/fragments/Components/RestaurantHero.graphql"

fragment GenericEntryCard on EntryInterface {
    uri
    title
    ... on card_Entry {
        description: cardDescription
        image: cardImage {
            ... on AssetInterface {
                ...GenericEntryCardAsset
            }

        }
    }
    ... on property_Entry {
        description: cardDescription
        image: cardImage {
            ... on AssetInterface {
                ...GenericEntryCardAsset
            }

        }
    }
    ... on apartment_Entry {
        description: cardDescription
        image: cardImage {
            ... GenericEntryCardAsset
        }
    }
    ... on story_Entry {
        contentHero {
            
                ... on contentHeroBlock_Entry {
                    description
                    image {
                        ... GenericEntryCardAsset
                    }
                }
            
        }
    }
    ... on restaurant_Entry {
        restaurantHero {
            
                ... RestaurantHero
            
        }
    }
    ... on page_Entry {
        contentHero {
            
                ... on contentHeroBlock_Entry {
                    description
                    image {
                        ... GenericEntryCardAsset
                    }
                }
            
        }
    }
}
